import axios from 'axios'
import laroute from '~/laroute'
import store from '~/store'
import moment from 'moment'
import PackingSlip from '~/_shared/models/PackingSlip'

export const state = {
  pickList: [],
  packingSlips: [],
  packingSlip: new PackingSlip(),
  savedPickList: {},
  pdf: undefined
}

export const getters = {
  pickList: state => state.pickList,
  packingSlips: state => state.packingSlips,
  packingSlip: state => state.packingSlip,
  savedPickList: state => state.savedPickList,
  pdf: state => state.pdf
}

export const mutations = {
  PICKLIST (state, data) {
    state.pickList = data
  },

  SAVED_PICKLIST (state, data) {
    state.savedPickList = data
  },

  PACKING_SLIPS (state, data) {
    state.packingSlips = data
  },

  PACKING_SLIP (state, data) {
    state.packingSlip = data
  },

  PDF (state, data) {
    state.pdf = data
  }
}

export const actions = {
  async generatePickList ({ commit }, soId) {
    const { data } = await axios.get(laroute.route('generate_pick_list', { companyAbbr: store.getters['auth/company'], id: soId }))
    commit('PICKLIST', data)
  },

  async fetchAll ({ commit }, filterData) {
    await axios.get(
      laroute.route('ps_filter', { companyAbbr: store.getters['auth/company'], ...filterData })
    ).then(res => {
      res.data.data.items.map((packingSlip) => {
        packingSlip.created_at = moment(packingSlip.created_at).format('YYYY-MM-DD')
      })
      commit('PACKING_SLIPS', res.data.data.items)
    })
  },

  async delete ({ commit }, { id, reason }) {
    await axios.patch(laroute.route('delete_packing_slip', { id }), { reason })
  },

  async getOne ({ commit }, id) {
    const { data } = await axios.get(laroute.route('get_packing_slip', { id }))

    commit('PACKING_SLIP', new PackingSlip(data.data.data.packingSlip))
  },

  async showPickList ({ commit }, { id }) {
    const { data } = await axios.get(laroute.route('show-picklist', { id }))

    commit('SAVED_PICKLIST', data)
  },

  async savePicklist ({ commit }, { picklist, mainInfo }) {
    const { data } = await axios.post(laroute.route('save-picklist',
      { companyAbbr: store.getters['auth/company'] }),
    { picklist, mainInfo })

    commit('SAVED_PICKLIST', data)
  },

  async generatePicklistPdf ({ commit }, { picklist, mainInfo }) {
    const data = {
      picklist: picklist,
      mainInfo: mainInfo
    }
    await axios.post(laroute.route('generate-picklist-pdf', { companyAbbr: this.getters['auth/company'] }),
      { data }, { responseType: 'arraybuffer' })
      .then((res) => {
        commit('PDF', res.data)
      })
      .catch((err) => {
        if (err.response.status === 422) {
          // What is going on? We extract errors extracted from  binary answer and converted to JSON object
          err.response.data.errors = JSON.parse(String.fromCharCode.apply(null, new Uint8Array(err.response.data))).errors
          throw err
        }
      })
  },

  async deletePicklist ({ commit }, { id }) {
    await axios.delete(laroute.route('delete-picklist', { id }))
  },

  async localPickListUpdate ({ commit }, list) {
    commit('PICKLIST', Object.assign([], list))
    return list
  },

  async createFromSO ({ commit }, newPackingSlip) {
    await axios.post(laroute.route('create-from-so',
      { companyAbbr: store.getters['auth/company'] }),
    { newPackingSlip }).then(res => {
      commit('PACKING_SLIP', new PackingSlip(res.data.data))
    }).catch(err => {
      throw err
    })
  },

  async createMiscellaneousIssue ({ commit }, newPackingSlip) {
    await axios.post(laroute.route('create-miscellaneous-issue',
      { companyAbbr: store.getters['auth/company'] }),
    { newPackingSlip }).then(res => {
      commit('PACKING_SLIP', new PackingSlip(res.data.data))
    })
  },

  async update ({ commit }, { id, packingSlip, items }) {
    await axios.patch(laroute.route('update-packing-slip', { id }), { packingSlip, items })
  },

  async localPackingSlipUpdate ({ commit }, packingSlip) {
    console.log('actions', packingSlip)
    commit('PACKING_SLIP', packingSlip)
  }
}



// WEBPACK FOOTER //
// ./resources/assets/js/store/modules/packingSlip.js